export const parseLabel = (label: string): string => {
  const category = label.toLowerCase();

  if (category.includes('items') || category.includes('listings') || category.includes('shop')) {
    return 'listings';
  }
  return category;
};
